import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useEntitlements } from "../entitlements/EntitlementContext";

export function canAccessPremiumApplication(entitlement, application) {
  if (application === "MSI" || application === "TEG") {
    return entitlement.isAdmin === true;
  }
  return entitlement.applications?.[application]?.enabled === true;
}

export default function PremiumRoute({ children, application }) {
  const entitlement = useEntitlements();
  const location = useLocation();
  if (entitlement.loading) return <div>Checking Premium access...</div>;
  if (!application && !entitlement.entitled) {
    return <Navigate to="/pricing" replace state={{ from: location.pathname }} />;
  }
  if (application && !canAccessPremiumApplication(entitlement, application)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
